const CONTEST_QUERY_KEY_PREFIX = 'contest';

export const ContestQueryKey = {
  FILTERS: (leagueId: string) => [CONTEST_QUERY_KEY_PREFIX, leagueId, 'filters'],
};
